import { ClientStatus } from 'api/adminApiClient';

const ALL_CLIENT_STATUSES: ClientStatus[] = Object.values(ClientStatus).filter(
  (value): value is ClientStatus => typeof value === 'number',
);

export const DEFAULT_OPERATIONAL_CLIENT_STATUSES: ClientStatus[] =
  ALL_CLIENT_STATUSES.filter((status) => status !== ClientStatus.Deleted);

export const ADMIN_FILTERABLE_CLIENT_STATUSES: ClientStatus[] =
  ALL_CLIENT_STATUSES;

const FILTERABLE_STATUS_SET = new Set(ADMIN_FILTERABLE_CLIENT_STATUSES);

export function isDefaultOperationalSelection(
  statuses: ClientStatus[],
): boolean {
  if (statuses.length !== DEFAULT_OPERATIONAL_CLIENT_STATUSES.length) {
    return false;
  }

  const selected = new Set(statuses);
  return DEFAULT_OPERATIONAL_CLIENT_STATUSES.every((status) =>
    selected.has(status),
  );
}

export function parseClientStatusesFromQuery(
  param: string | string[] | null | undefined,
): ClientStatus[] {
  if (!param) {
    return [...DEFAULT_OPERATIONAL_CLIENT_STATUSES];
  }

  const raw = Array.isArray(param) ? param.join(',') : param;
  const parsed = raw
    .split(',')
    .map((value) => Number.parseInt(value.trim(), 10))
    .filter(
      (value) =>
        !Number.isNaN(value) && FILTERABLE_STATUS_SET.has(value as ClientStatus),
    ) as ClientStatus[];

  return parsed.length > 0 ? parsed : [...DEFAULT_OPERATIONAL_CLIENT_STATUSES];
}

export function serializeClientStatusesToQuery(
  statuses: ClientStatus[],
): string | undefined {
  if (isDefaultOperationalSelection(statuses)) {
    return undefined;
  }

  return statuses.join(',');
}

export function getClientStatusesForApi(
  statuses: ClientStatus[],
): ClientStatus[] | undefined {
  return isDefaultOperationalSelection(statuses) ? undefined : statuses;
}
